import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const resources = [
    { label: 'Basetao Spreadsheet Guide', to: '/articles/basetao-spreadsheet/' },
    { label: 'Home', to: '/' },
    { label: 'Categories', to: '/#categories' },
    { label: 'FAQ', to: '/#faq' },
  ];

  const company = [
    { label: 'About', to: '/about/' },
    { label: 'Contact', to: '/contact/' },
    { label: 'Privacy Policy', to: '/privacy-policy/' },
    { label: 'Disclaimer', to: '/disclaimer/' },
  ];

  return (
    <footer className="bg-secondary-100/60">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-base" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">
                Basetao Sheet Guide
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t('footer.resources')}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {resources.map((item) => (
                <li key={item.to}>
                  {item.to.startsWith('/#') ? (
                    <a
                      href={item.to}
                      className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      to={item.to}
                      className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t('footer.company')}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {company.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                >
                  {t('nav.mainSite')}
                  <i className="ri-external-link-line text-xs" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300/60 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            {t('footer.disclaimer')}
          </p>
          <div className="mt-4 flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
            <p className="text-xs text-foreground-500">
              © 2026 Basetao Sheet Guide. All rights reserved.
            </p>
            <p className="text-xs text-foreground-500">basetaosheet.cfd</p>
          </div>
        </div>
      </div>
    </footer>
  );
}